import { render, staticRenderFns } from "./FilterSort.vue?vue&type=template&id=2f0fdc06"
import script from "./FilterSort.vue?vue&type=script&lang=js"
export * from "./FilterSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports